export default {
  API_URL: import.meta.env.VITE_API_URL || "https://testapi.xs2event.com/v1",
  STRAPI_API_URL: import.meta.env.VITE_STRAPI_API_URL || "https://cms.xs2event.com/api",
  CDN_URL: "https://cdn.xs2event.com",
  XS2TICKET: "http://localhost:3002/download",
  ENV: "development",
  SENTRY_ENABLE: false,
  SENTRY_DSN: undefined,

  SENTRY_SAMPLE_RATE: 1.0,
  EVENT_MEDIA_BASE_URL: "https://cdn.xs2event.com/media-production",
  MEDIA_CONTENT_URL: import.meta.env.VITE_MEDIA_CONTENT_URL || "https://cdn.xs2event.com/mediacontent-local",
  FLAGS_BASE_URL: "https://cdn.xs2event.com/flags-test",
  EVENT_MEDIA_COVER_PHOTO: "cover-photo",
  FORMULA_ONE_MEDIA_COVER_PHOTO: "https://cdn.xs2event.com/events-test/formula-1/cover-photo",
  VERSION: "776cfde4",
  CLICKY: 101405593,
  HOTJAR: 3055862, // NB. 3357273 in #34
  WEBAPP: "portalv2",
  ITINERARY_BASE_URL: "https://testitineraries.xs2event.com",
};
